import { render, staticRenderFns } from "./add.vue?vue&type=template&id=858690d0&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=858690d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858690d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('858690d0')) {
      api.createRecord('858690d0', component.options)
    } else {
      api.reload('858690d0', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=858690d0&scoped=true", function () {
      api.rerender('858690d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/dishesManagement/add.vue"
export default component.exports